import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import pvxLogoBlack from '../../assets/images/pvx-logo-black-text.svg';
import invalidLoginSvg from '../../assets/images/invalid-login.svg';

const InvalidInvitationAccess: FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        backgroundColor: '#F7F8FA',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '3rem',
      }}
    >
      <Box
        sx={{
          border: '1px solid #E8EAEB',
          boxShadow: '0px 0px 10px 0px #00000033',
          width: '100%',
          maxWidth: '600px',
          borderRadius: '0.75rem',
          padding: '4rem 2.5rem',
          backgroundColor: '#FFFFFF',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {/* Logo */}
        <Box sx={{ alignSelf: 'center', mb: '4rem' }}>
          <img
            src={pvxLogoBlack}
            alt="PvX Partners"
            style={{ height: '2.5rem', cursor: 'pointer' }}
            onClick={() => window.open('https://pvxpartners.com', '_blank', 'noopener,noreferrer')}
          />
        </Box>

        {/* Illustration */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: '1.5rem',
          }}
        >
          <img src={invalidLoginSvg} alt="Invitation No Longer Valid" style={{ height: '9rem' }} />
        </Box>

        {/* Title */}
        <Typography
          sx={{
            fontSize: '1.5rem',
            fontWeight: 700,
            color: '#162936',
            textAlign: 'center',
            mb: '0.75rem',
          }}
        >
          Invitation No Longer Valid
        </Typography>

        {/* Body */}
        <Typography
          sx={{
            fontSize: '1rem',
            fontWeight: 500,
            color: '#6C6C6C',
            textAlign: 'center',
            mb: '1rem',
          }}
        >
          This invitation is no longer valid because access has been removed or the invitation has
          been revoked.
        </Typography>

        {/* Footer */}
        <Typography
          sx={{
            fontSize: '0.875rem',
            fontWeight: 400,
            color: '#6C6C6C',
            textAlign: 'center',
          }}
        >
          Please contact your Dashboard Owner to request a new access invitation.
        </Typography>
      </Box>
    </Box>
  );
};

export default InvalidInvitationAccess;
